import { EventEmitter, Injectable } from '@angular/core';
import { IResponseMessage } from '@shared/interfaces/certify/IResponse-message';
import { BehaviorSubject } from 'rxjs';
import { ISelectControl } from '@shared/interfaces/certify/recipe';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  [x: string]: any;
  loadByMock: EventEmitter<boolean> = undefined;
  loadEvt: EventEmitter<boolean> = undefined;
  notifierMessage: EventEmitter<IResponseMessage> = undefined;
  controlBehavior: EventEmitter<any> = undefined;
  shareData: EventEmitter<any> = undefined;
  shareCheckGridData: EventEmitter<any> = undefined;
  gridRawSelectedItem: EventEmitter<any> = undefined;
  otherEmmiters: EventEmitter<any> = undefined;
  cleanSearch: EventEmitter<any> = undefined;
  onEditionMode: EventEmitter<boolean> = undefined;
  reloadTbl: EventEmitter<boolean> = undefined;
  onParentEditionMode: EventEmitter<boolean> = undefined;
  actionRowEvt: EventEmitter<any> = undefined;
  readDataParam: EventEmitter<string> = undefined;
  modalOpened: EventEmitter<boolean> = undefined;
  selectedData: EventEmitter<boolean> = undefined;
  hashDetected$ = new BehaviorSubject<boolean>(null);
  controlSelectChange: EventEmitter<ISelectControl> = undefined;

  constructor() {}

  /**
   * @description Init with this method when a template form will be used.
   * @example initEmmiter(['nameEmmitetr1','nameEmmitetr2']).
   */
  initEmitter(nameEmitters: string[]): void {
    nameEmitters.forEach((element: string) => {
      if (this.checkProperty(element)) {
        this[element] =
          this[element] && this[element].observers && this[element].observers.length > 0
            ? this[element]
            : new EventEmitter();
      }
    });
  }

  /**
   * @description Unsubscribe an emmiter if is loaded.
   * @example endEmmiter(['nameEmmitetr1','nameEmmitetr2']).
   */
  endEmitter(nameEmmiters: Array<string>): void {
    nameEmmiters.forEach((element) => {
      if (this[element]) {
        const observersLength = this[element]?.observers?.length ?? 0;
        if (observersLength === 0) {
          this[element].unsubscribe();
        }
      }
    });
  }

  emit(event: any, data: any) {
    if (this[event] && !this[event].closed) {
      this[event].emit(data);
    } else {
      console.warn(`Emit: Event '${event}' does not exist or is not an EventEmitter.`);
    }
  }

  checkProperty(prop: string) {
    return this.hasOwnProperty(prop);
  }
}
